<template>
  <div v-if="book && user">
    <v-container fluid class="content-container">
      <v-layout row wrap>
        <v-flex md6 class="book-top">
          <div class="go-back">
            <i class="material-icons back-icon">arrow_back</i>
          </div>
          <div class="heading heading-top then-card">Your Book</div>
          <card :book="book" :single="true"></card>
        </v-flex>
        <v-flex md6 class="actions-col">
          <!-- <get-reviewed :book="book"></get-reviewed> -->
          <actions :book="book" :single="true"></actions>
          <author-message :book="book"></author-message>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid class="content-container content-last">
      <v-layout row wrap>
        <v-flex md6 class="first-row first-row-book">
          <template v-if="book.status === 'ChangesRequested'">
            <div class="heading then-card">Requested Changes</div>
            <div class="staff-note talk-bubble tri-right btm-left" v-html="book.rejection_note"></div> <!-- {{ book.rejection_note }}</div> -->
            <div class="staff-note-message">
              Our staff has requested some changes to your submission to ensure
              that reviewers can read and enjoy your book easily. Please read
              our note and click "Edit" above to update and resubmit your book.
            </div>
          </template>
          <template v-else>
            <template
              v-if="
                lookingForReaders.length > -1 && (book.status === 'Available' || book.status === 'HoldingUnproven')
              "
            >
              <div class="heading then-card">In Progress Reviews</div>
              <div
                class="no-readers-message"
                v-if="book.stats.looking_for_reviews < 1 && user.is_late_unproven"
              >
              All additional review requests will be held until you complete a review and have it approved on Pubby. Please contact support with any questions!
              </div>
              <div
                class="no-readers-message"
                v-else-if="book.stats.looking_for_reviews < 1"
              >
                You're not looking for any readers right now. Use the
                <span class="get-reviewed-label">Get&nbsp;Reviewed</span> button
                above to find your next reader.
              </div>
              <looking-for-list
                :assignments="lookingForReaders"
                :averageRating="4"
                :book="book"
              ></looking-for-list>
              <div class="looking-tools">
                <div class="looking-tools-meter">
                  <looking-speed
                    :assignments="lookingForReaders"
                    :book="book"
                    :isLateUnproven="user.is_late_unproven"
                  ></looking-speed>
                </div>
                <div class="looking-tools-boost">
                  <!-- <boost-your-book
                :assignments="lookingForReaders"
              ></boost-your-book> -->
                </div>
              </div>
            </template>

            <div class="heading then-card">Book Reviews</div>
            <template v-if="reviews.length">
              <review-list :reviews="reviews" :averageRating="4"></review-list>
            </template>
            <template v-else-if="!assignmentsLoaded"></template>
            <template v-else>
              <no-content>No book reviews... yet!</no-content>
              <br />
              <br />
            </template>
          </template>
        </v-flex>
        <v-flex md6>
          <div class="heading then-card">Book Activity</div>
          <activity-timeline
            v-if="events"
            :events="events"
            :book="book"
          ></activity-timeline>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import Bus from "@/modules/Bus";
import Finagle from "@/modules/Finagle";
import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import ReviewList from "@/components/Review/List";
import LookingForList from "@/components/Review/LookingForList";
import Card from "@/components/Book/Card";
import GetReviewed from "@/components/Book/GetReviewed";
import Actions from "@/components/Book/Actions";
import ActivityTimeline from "@/components/Activity/Timeline";
import ReviewChart from "@/components/Book/ReviewChart";
import AuthorMessage from "@/components/Book/AuthorMessage";
import NoContent from "@/components/Page/NoContent";
import { mapState } from "vuex";
import BoostYourBook from "../components/Review/BoostYourBook.vue";
import LookingSpeed from "../components/Review/LookingSpeed.vue";

export default {
  name: "Page",
  components: {
    Head,
    Card,
    Actions,
    Heading,
    ReviewList,
    ReviewChart,
    AuthorMessage,
    ActivityTimeline,
    GetReviewed,
    NoContent,
    LookingForList,
    BoostYourBook,
    LookingSpeed,
  },
  data: function () {
    return {
      book: null,
      assignments: [],
      assignmentsLoaded: false,
      reviews: [],
      lookingForReaders: [],
    };
  },
  computed: {
    bookId: function () {
      return this.$route.params.id;
    },
    ...mapState({
      events: "events",
      user: "user",
    }),
    parsedRejectionNote: function () {
      return this.book.rejection_note.replaceAll('\\','\\\\')
    },
  },
  watch: {
    user(newValue, oldValue) {
      const user = newValue;

      if (user && user.is_vp_suspended_author) {
        this.book.is_vp_suspended = true;
      }

      if (user && user.is_late_unproven && this.book.status === "Available" && this.book.stats.looking_for_reviews === 0) {
          this.book.status = "HoldingUnproven"
      }
    },
  },
  methods: {
    async loadData() {
      this.book = await Back.book(this.bookId);

      if (this.book.status === "Editing") {
        this.$router.push("/books/edit/" + this.book.id);
        return;
      }

      if (this.user && this.user.is_late_unproven && this.book.status === "Available" && this.book.stats.looking_for_reviews === 0) {
          this.book.status = "HoldingUnproven"
      }
      if (this.user && this.user.is_vp_suspended_author) {
        this.book.is_vp_suspended = true
      }

      if (this.book && this.book.id || this.bookId) {
        this.assignments = await Back.assignments({
          book_id: (this.book && this.book.id) ? this.book.id : this.bookId,
          sort: "newest",
          end: 30,
        });
      }
      
      this.assignmentsLoaded = true;
      this.lookingForReaders = Finagle.gatherOpenAssignments(this.assignments);
      this.reviews = Finagle.gatherApprovedReviews(this.assignments);

      var holdingCount =0;
      var openCount = 0;
      var assignedCount = 0;

      for (var a in this.assignments) {
        var assignment = this.assignments[a];

        if (assignment.status === "HoldingUnproven") {
          holdingCount++;
          assignment.looking_for_count = holdingCount;
        }
        if (assignment.status === "Open") {
          openCount++;
          assignment.looking_for_count = openCount;
        }
        if (assignment.status === "Assigned") {
          assignedCount++;
          assignment.looking_for_count = assignedCount;
        }
      }
    },
  },
  async created() {
    await this.loadData();

    Bus.$on("UserChanged", async () => {
      await this.loadData();
    });
  },
};

function findBook(books, id) {
  for (const b in books) {
    if (books[b].id === id) {
      return books[b];
    }
  }
}
</script>

<style scoped lang="scss">
.staff-note {
  padding: 12px 40px 12px 30px;
  font-size: 14.5pt;
  line-height: 1.5em;
  font-family: $font-family;
  white-space: pre-line
}

.staff-note-message {
  margin: 12px 30px;
  max-width: 820px;
  padding: 20px;
  border-radius: 8px;
  // background: #ffe6ad;
  // color: darken(#b59505, 20%);
  background: $color-red;
  color: #ffe0b2;
  font-size: 13.5pt;
  font-family: $font-family;
}
.talk-bubble {
  margin: 12px 30px;
  display: inline-block;
  position: relative;
  max-width: 820px;
  padding: 20px;
  border-radius: 8px;
  background: #daedff;
  color: darken(#b59505, 20%);
  font-size: 13.5pt;
  font-family: $font-family;
}
.tri-right.btm-left:after{
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	left: 0px;
  right: auto;
  top: auto;
	bottom: -20px;
	border: 22px solid;
	border-color: transparent transparent transparent #daedff;
}
.tri-right.btm-right:after{
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
  left: auto;
	right: 10px;
	bottom: 0px;
	border: 12px solid;
	border-color: #daedff #daedff transparent transparent;
}

.looking-tools {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;

  .looking-tools-meter {
    width: 400px;
    max-width: 400px;
  }
  .looking-tools-boost {
    display: none;
    width: 300px;
    max-width: 300px;
    flex: 1;
    margin-left: auto;
    margin-right: 50px;
  }
}

.no-readers-message {
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin-bottom: 28px;
  padding: 18px 40px 22px 30px;
  border-radius: 8px;
  font-size: 12.5pt;
  font-family: "Source Sans Pro";
}

.get-reviewed-label {
  color: #f57c00 !important;
  font-weight: 600 !important;
  //text-transform: uppercase;
}
</style>